var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "helloWorld" } }, [
      _c("img", {
        staticClass: "logo",
        attrs: { alt: "Vue logo", src: require("../../static/images/logo.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "hello" }, [
        _c("h1", [_vm._v("欢迎使用果诚行提供的服务")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n      传播智慧,历练经典,海纳百川,乘风而拓,点燃创意与生活的新阶层."
          ),
          _c("br"),
          _vm._v(
            "\n      定位精准传播,为阶层精英提供思想品味盛典,小众经典打造,每一个人每天获得与众不同的领航思想. "
          ),
          _c("br"),
          _vm._v(
            "\n      欢迎你,从此这里将是你的智慧集源地，打造出你所要、所需、渴求、渴盼的科技生活。\n    "
          )
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("提供服务")]),
        _vm._v(" "),
        _c("ul", [
          _c("li"),
          _vm._v(" "),
          _c("li", [_vm._v("微信小程序：果城行丨南充实时公交")]),
          _vm._v(" "),
          _c("li", [_vm._v("支付宝小程序：果城行丨南充实时公交")])
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("联系方式")]),
        _vm._v(" "),
        _c("ul", { staticClass: "contact" }, [
          _c("li", [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.nanchongcity.com",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v("公司官网")]
            )
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("联系电话：15196764388")]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "办公地址：四川省南充市高坪区江东中路四段2号明宇广场5号楼27层22号"
            )
          ]),
          _vm._v(" "),
          _c("li")
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n    Copyright © 2019-2026 "),
        _c("a", { attrs: { href: "http://www.beian.miit.gov.cn" } }, [
          _c("em", [_vm._v(" 蜀ICP备19023482号-1 ")])
        ]),
        _vm._v("南充果诚行科技有限公司版权所有\n  ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29fa7a92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29fa7a92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/HelloWorld.vue
// module id = null
// module chunks = 